var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDollarSquare = function SvgDollarSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#787473",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.781 9.553c0 .86.66 1.553 1.48 1.553h1.674c.713 0 1.293-.606 1.293-1.353 0-.813-.353-1.1-.88-1.286L6.66 7.533c-.526-.186-.88-.473-.88-1.286 0-.747.58-1.354 1.294-1.354h1.673c.82 0 1.48.694 1.48 1.554M8 4v8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#787473",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 14.667H6c-3.334 0-4.667-1.334-4.667-4.667V6c0-3.333 1.333-4.667 4.667-4.667h4c3.333 0 4.666 1.334 4.666 4.667v4c0 3.333-1.333 4.667-4.666 4.667"
  })));
};
export default SvgDollarSquare;